import React from 'react';
import { BoxSelector, BoxColumn, BoxItem } from '@wkda/styleguide';
/**
 * @typedef {import('@wkda/styleguide').BoxSelectorProps} BoxSelectorProps
 * @typedef {import('@wkda/styleguide').OptionItem} OptionItem
 * @typedef {OptionItem & {className?: string}} BoxSelectOptionItem
 * @typedef {Omit<BoxSelectorProps, 'children'> & {options: BoxSelectOptionItem[]}} BoxSelectProps
 */

/**
 * @param {BoxSelectProps} props
 */

export function BoxSelect(_ref) {
  let {
    options,
    columnClassName,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(BoxSelector, props, options.map(function boxItemMapper(item) {
    const key = typeof item.value === 'boolean' ? "" + item.value : item.value;
    return /*#__PURE__*/React.createElement(BoxColumn, {
      key: key,
      className: columnClassName
    }, /*#__PURE__*/React.createElement(BoxItem, {
      value: item.value,
      className: item.className
    }, item.label));
  }));
}